<template>
  <div>
    <a-page-header
      style="border: 1px solid rgb(235, 237, 240);background: #ffffff"
      title="网站探索"
      :breadcrumb=" { props: { routes:[{path:'/',breadcrumbName:$t('HOME')}
      ,{path:'/website-news',breadcrumbName:'网站探索列表'}
      ,{path:`/website-news/${newsId}`,breadcrumbName:'探索详情'}
      ] } }"
      v-if="newsId"
    />
    <div style="position: relative">
      <a-menu :defaultSelectedKeys="['detail']" mode="horizontal">
        <a-menu-item
          key="detail"
          @click="()=>{this.$router.push(`/website-news/${newsId}`)}">
          <a-icon type="mail"/>
          网站探索
        </a-menu-item>
        <a-menu-item
          key="content"
          :disabled="!newsId"
          @click="()=>{this.$router.push(`/website-news/${newsId}/content`)}">
          <a-icon type="mail"/>
          探索详情
        </a-menu-item>
      </a-menu>
    </div>
    <a-card style="margin: 16px" :bordered="false">
      <div>
        <a-form-model ref="form" :model="form.data" :rules="form.rules">
          <a-form-model-item label="类型" required>
            <dict-select v-model="form.data.articleType" dict-code="WEBSITE_NEWS_TYPE"/>
          </a-form-model-item>
          <a-form-model-item :label="$t('TITLE')||'标题'" required>
            <a-textarea placeholder="标题" v-model="form.data.title" :rows="2"/>
          </a-form-model-item>
          <a-form-model-item :label="$t('SUB_TITLE')||'副主题'">
            <a-input v-model="form.data.subTitle"/>
          </a-form-model-item>
          <a-form-model-item :label="$t('POST_AT')||'发表时间'">
            <a-date-picker
              v-model="form.data.postAt"
              value-format="YYYY-MM-DDTHH:mm:ss"
              :show-time="{ defaultValue: moment('00:00:00', 'HH:mm:ss') }"
              type="datetime"
              placeholder="">
            </a-date-picker>
          </a-form-model-item>
          <a-form-model-item label="分类" prop="type">
            <dict-select v-model="form.data.type" dict-code="WEBSITE_INDEX_POSTER_TYPE"/>
          </a-form-model-item>
          <a-form-model-item label="图片封面(560*730)" prop="coverPath" v-if="form.data.type === 'IMAGE'">
            <div class="a-input">
              <cropper-uploader
                v-model="form.data.coverPath"
                :imageUrl="form.data.coverPath"
                :options="coverOptions"
                avatarTextTop=""
                avatarTextBottom=""/>
            </div>
          </a-form-model-item>
          <a-form-model-item :label="$t('DESCRIPTION')||'描述'">
            <div class="a-input">
              <a-textarea placeholder="description" v-model="form.data.description" allow-clear/>
            </div>
          </a-form-model-item>
          <a-form-model-item :label="'链接'">
            <div class="a-input">
              <div class="add-link-btn">
                <a @click="() => {form.data.links.push({ name: '', url: ''})}">添加链接</a>
              </div>
              <div
                class="links"
                :key="index"
                v-for="(link, index) in form.data.links">
                <div>
                  <a-input class="link-content" v-model=link.name placeholder="链接Title"/>
                  <a-input class="link-content" v-model=link.url placeholder="链接地址"/>
                  <span class="move-choice-btn"><a
                    @click="(() => {form.data.links = form.data.links.filter((ele, itemIndex) => itemIndex !== index)})">移除</a></span>
                </div>
              </div>
            </div>
          </a-form-model-item>
          <a-form-model-item>
            <a-space>
              <a-button
                type="primary"
                v-if="!newsId"
                @click="onAdd">{{ $t('CREATE') || '创建' }}
              </a-button>
              <a-button
                type="primary"
                v-if="newsId"
                @click="onUpdate">{{ $t('UPDATE') || '更新' }}
              </a-button>
              <a-button @click="onCancel">{{ $t('CANCEL') || '取消' }}</a-button>
            </a-space>
          </a-form-model-item>
        </a-form-model>
      </div>
    </a-card>
    <a-modal
      :footer="null"
      append-to-body
      title="视频预览"
      v-model="video.visible">
      <video
        v-if="video.visible"
        ref="video"
        webkit-playsinline="true"
        playsinline="true"
        x-webkit-airplay="true"
        x5-video-player-type="h5"
        x5-video-player-fullscreen="ture"
        x5-video-orientation="portraint"
        style="width: 100%;height: auto"
        autoplay
        preload="auto"
        muted="true"
        :src="form.data.videoPath">
        您的浏览器不支持 HTML5
      </video>
    </a-modal>
  </div>
</template>

<script>
import moment from 'moment';
import { _addNews, _queryNews, _updateNews, } from '@/api/websiteNewsApi';
import DictSelect from '../../../components/DictSelect.vue';
import CropperUploader from '@/components/CropperUploader.vue';

async function getNews() {
  const result = await _queryNews(this.newsId);
  if (result) {
    this.form.data.title = result.title;
    this.form.data.subTitle = result.subTitle;
    this.form.data.postAt = result.postAt;
    this.form.data.brandId = result.brandId;
    this.form.data.coverPath = result.coverPath;
    this.form.data.topImagePath = result.topImagePath;
    this.form.data.content = result.content;
    this.form.data.links = JSON.parse(result.links);
    this.form.data.tags = result.tags ? result.tags.split(',') : [];
    this.form.data.type = result.type;
    this.form.data.videoPath = result.videoPath;
    this.form.data.description = result.description;
    this.form.data.articleType = result.articleType;
    this.form.data.shadePath = result.shadePath;
  }
}

async function onAdd() {
  this.$refs.form.validate(async (valid) => {
    if (valid) {
      const result = await _addNews({
        title: this.form.data.title,
        subTitle: this.form.data.subTitle,
        postAt: this.form.data.postAt,
        brandId: this.form.data.brandId,
        coverPath: this.form.data.coverPath,
        topImagePath: this.form.data.topImagePath,
        links: JSON.stringify(this.form.data.links),
        content: this.form.data.content,
        tags: this.form.data.tags ? this.form.data.tags.join(',') : null,
        videoPath: this.form.data.videoPath,
        type: this.form.data.type,
        description: this.form.data.description,
        articleType: this.form.data.articleType,
        shadePath: this.form.data.shadePath,
      });
      if (result) {
        if (this.onSubmitHandler) {
          this.$message.success(this.$t('ADD_SUCCESS'));
          this.onSubmitHandler();
        }
      }
    }
  });
}

async function onUpdate() {
  this.$refs.form.validate(async (valid) => {
    if (valid) {
      const result = await _updateNews(this.newsId, {
        title: this.form.data.title,
        subTitle: this.form.data.subTitle,
        postAt: this.form.data.postAt,
        brandId: this.form.data.brandId,
        coverPath: this.form.data.coverPath,
        topImagePath: this.form.data.topImagePath,
        links: JSON.stringify(this.form.data.links),
        content: this.form.data.content,
        videoPath: this.form.data.videoPath,
        type: this.form.data.type,
        tags: this.form.data.tags ? this.form.data.tags.join(',') : null,
        description: this.form.data.description,
        articleType: this.form.data.articleType,
        shadePath: this.form.data.shadePath,
      });
      if (result) {
        this.$message.success(this.$t('UPDATE_SUCCESS'));
        if (this.onSubmitHandler) {
          this.onSubmitHandler();
        }
      }
    }
  });
}

function onCancel() {
  if (this.onCancelHandler) {
    this.onCancelHandler();
  } else {
    this.$router.go(-1);
  }
}

function reviewVideo() {
  if (this.form.data.videoPath) {
    this.video.visible = true;
  }
}

export default {
  name: 'WebsiteNewsEdit',
  components: {
    // SimpleUploaderS3,
    CropperUploader,
    // HtmlEditor,
    DictSelect,
  },
  props: {
    newsId: String,
    onSubmitHandler: Function,
    onCancelHandler: Function,
  },
  watch: {
    newsId() {
      if (this.newsId) {
        this.getNews();
      }
    },
  },
  methods: {
    moment,
    onAdd,
    onUpdate,
    onCancel,
    getNews,
    reviewVideo,
  },
  data() {
    return {
      video: {
        visible: false,
        url: '',
      },
      goodsBrand: {
        data: [],
      },
      coverOptions: {
        autoCrop: true, // 是否默认生成截图框
        autoCropWidth: 560, // 默认生成截图框宽度
        autoCropHeight: 730, // 默认生成截图框高度
        fixedBox: false, // 是否固定截图框大小 不允许改变
        previewsCircle: false, // 预览图是否是圆形
        serviceType: 'S3',
        title: '修改图片',
      },
      form: {
        data: {
          title: '',
          subTitle: '',
          description: '', // 描述
          type: '',
          videoPath: '',
          postAt: moment().format('YYYY-MM-DDTHH:mm:ss'),
          brandId: '',
          coverPath: '',
          topImagePath: '',
          content: '',
          contentImages: '',
          links: [],
          tags: [],
          articleType: '',
          shadePath: '',
        },
        rules: {
          title: [{
            required: true,
            trigger: 'blur',
          }],
          code: [{
            required: true,
            trigger: 'blur',
          }],
          type: [{
            required: true,
            trigger: 'blur',
          }],
          coverPath: [{
            required: true,
            trigger: 'blur',
          }],
          videoPath: [{
            required: true,
            trigger: 'blur',
          }]
        },
        title: '',
      },
    };
  },
  async created() {
    if (this.newsId) {
      await this.getNews();
    }
  },
};
</script>

<style scoped lang="css">
.add-link-btn {
  text-align: left;
  line-height: 40px;
  width: 100%;
}

.link-content {
  text-align: left;
  line-height: 40px;
  width: 350px;
  margin-right: 20px;
}
</style>
